export interface BlogPostMetadata {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  tags: string[];
  readingTime: string;
  author: string;
}

export const blogPosts: BlogPostMetadata[] = [
  {
    slug: 'stop-saying-just-hi',
    title: 'Stop Saying Just "Hi" - Respect People\'s Time',
    excerpt:
      'Why starting conversations with just "hi" is inefficient and disrespectful. A guide to better professional communication.',
    date: '2026-02-15',
    tags: ['Communication', 'Professional Etiquette', 'Productivity', 'Rant'],
    readingTime: '5 min read',
    author: 'Ravindra Singh Rathor',
  },
  {
    slug: 'why-i-dont-refer-strangers',
    title: 'Why I Won\'t Refer People I Haven\'t Worked With',
    excerpt:
      'A candid take on professional referrals, integrity, and why blindly referring strangers is unfair to everyone involved.',
    date: '2026-02-15',
    tags: ['Career', 'Professional Ethics', 'Workplace', 'Integrity'],
    readingTime: '6 min read',
    author: 'Ravindra Singh Rathor',
  },
];

export function getBlogPost(slug: string): BlogPostMetadata | undefined {
  return blogPosts.find(post => post.slug === slug);
}

export function getAllBlogPosts(): BlogPostMetadata[] {
  return blogPosts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}

export function getBlogPostsByTag(tag: string): BlogPostMetadata[] {
  return blogPosts.filter(post => post.tags.includes(tag));
}
